import { render, staticRenderFns } from "./UpdateTransferStockConsignment.vue?vue&type=template&id=4728da98"
import script from "./UpdateTransferStockConsignment.vue?vue&type=script&lang=js"
export * from "./UpdateTransferStockConsignment.vue?vue&type=script&lang=js"
import style0 from "./UpdateTransferStockConsignment.vue?vue&type=style&index=0&id=4728da98&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports